import React from "react";
import { isViewVisible } from "../../../utils/ViewSettings";
import VouchersView from "./components/VouchersView";
import Rbac from "../../../utils/Rbac";

export const rbac = new Rbac({
  _rbac: {
    admin: {
      write: true,
      editVoucher: true,
      removeVoucher: true,
    },
    manager: {
      write: false,
      editVoucher: true,
      removeVoucher: true,
    },
    "manager-location": {
      write: false,
      editVoucher: false,
      removeVoucher: false,
    },
    user: {
      write: false,
      editVoucher: false,
      removeVoucher: false,
    },
    "garage-staff": {
      write: false,
      editVoucher: false,
      removeVoucher: false,
    },
  },
});

export const VouchersPage = (props) => {
  let _view = typeof props.view === "undefined" || props.view === null ? "index" : props.view;
  let indexView = isViewVisible("vouchers", "vouchers") ? "vouchers" : "";
  return (
    <>
      {(_view === "vouchers" || (_view === "index" && indexView === "vouchers")) && (
        <VouchersView
          name={"vouchers"}
          addd={props.add}
          dispatch={props.dispatch}
          params={props.params}
          returnPath={props.returnPath}
        />
      )}
    </>
  );
};
